"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var react_bootstrap_1 = require("react-bootstrap");
var Theme_1 = require("../Theme");
exports.copyRightContainerStyling = function (theme) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding: ", ";\n        background-color: ", ";\n    "], ["\n        padding: ", ";\n        background-color: ", ";\n    "])), Theme_1.applyTheme(theme, function (t) { return t.padding.extraSmallPadding; }), Theme_1.applyTheme(theme, function (t) { return t.colors.primaryBackground; }));
};
exports.footerPositionStyling = function (theme) {
    return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width:100%;\n    "], ["\n        width:100%;\n    "])));
};
exports.defaultCopyRightStyling = function (theme) {
    return core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        text-align: center;\n        margin-bottom: 0;\n    "], ["\n        text-align: center;\n        margin-bottom: 0;\n    "])));
};
exports.loveHardIconStyling = function (theme) {
    return core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: red;\n    "], ["\n        color: red;\n    "])));
};
exports.onlineOrbitLinkStyling = function (theme) {
    return core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        color: ", " !important;\n        text-decoration: underline;\n    "], ["\n        color: ", " !important;\n        text-decoration: underline;\n    "])), Theme_1.applyTheme(theme, function (t) { return t.colors.primaryText; }));
};
exports.footerInfoContainerStyling = function (theme) {
    return core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        padding: ", ";\n        padding-top: ", ";\n        background-color: ", ";\n    "], ["\n        padding: ", ";\n        padding-top: ", ";\n        background-color: ", ";\n    "])), Theme_1.applyTheme(theme, function (t) { return t.padding.smallPadding; }), Theme_1.applyTheme(theme, function (t) { return t.padding.mediumPadding; }), Theme_1.applyTheme(theme, function (t) { return t.colors.secondaryBackground; }));
};
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.getCopyRight = function () {
        if (this.props.copyRight !== undefined) {
            return this.props.copyRight;
        }
        else {
            return core_1.jsx("p", { css: exports.defaultCopyRightStyling },
                "Made with ",
                core_1.jsx("span", { css: exports.loveHardIconStyling }, "\u2665"),
                " by ",
                core_1.jsx("a", { href: "https://onlineorbit.com", css: exports.onlineOrbitLinkStyling }, "Online Orbit"),
                ".");
        }
    };
    Footer.prototype.render = function () {
        var _this = this;
        var colSize = 12;
        if (this.props.links && this.props.contactInfo) {
            colSize = 6;
        }
        return (core_1.jsx("div", { css: exports.footerPositionStyling },
            (this.props.links || this.props.contactInfo) &&
                core_1.jsx("div", { css: function (t) { return [exports.footerInfoContainerStyling(t), _this.props.footerInfoContainerStyling !== undefined ? _this.props.footerInfoContainerStyling(t) : undefined]; } },
                    core_1.jsx(react_bootstrap_1.Container, null,
                        core_1.jsx(react_bootstrap_1.Row, null,
                            core_1.jsx(react_bootstrap_1.Col, { sm: colSize }, this.props.links),
                            core_1.jsx(react_bootstrap_1.Col, { sm: colSize }, this.props.contactInfo)))),
            core_1.jsx(react_bootstrap_1.Container, { fluid: true, css: function (t) { return [exports.copyRightContainerStyling(t), _this.props.copyRightContainerStyling !== undefined ? _this.props.copyRightContainerStyling(t) : undefined]; } }, this.getCopyRight())));
    };
    return Footer;
}(React.Component));
exports["default"] = Footer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Footer.js.map